const endpoints = {
	get: "/cart.json",
	add: "/cart/add.js",
	update: "/cart/update.js",
	change: "/cart/change.js",
};

const fetchCart = (shouldOpen = true) => {
  fetch(endpoints.get)
    .then(response => response.json())
    .then(data => {
      const elToggles = document.querySelectorAll('cart-toggle');
      const elCounts = document.querySelectorAll('[data-cart-count]');
      const elDrawer = document.querySelector('cart-drawer');

      elToggles.forEach(el => el.setAttribute('count', data.item_count));
      elCounts.forEach(el => el.innerHTML = `(${data.item_count})`);
      shouldOpen && elDrawer.setAttribute('open', true);

      window.cart = data;
      window.renderCart();
    })
    .catch()
}

const postCart = async (data, endpoint) => {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  const json = await response.json();
  fetchCart();
  return json;
}

window.addToCart = (data) => { postCart(data, endpoints.add) };
window.updateCart = (data) =>{ postCart(data, endpoints.update) };

const formatMoney = (number, precision = 2, thousands = ',', decimal = '.') => {
  if (isNaN(number) || number == null) {
    return 0;
  }

  if (precision == 0 && (number / 100.0) % 1 != 0) {
    number = (number / 100.0).toFixed(2);
  } else {
    number = (number / 100.0).toFixed(precision);
  }

  const { active: activeCurrency } = window.Shopify.currency;
  const currencySymbol =  window.currencies && window.currencies[activeCurrency] ? window.currencies[activeCurrency] : '$';

  let parts = number.split(".");
	let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `${currencySymbol}1` + thousands);
  let cents = parts[1] ? decimal + parts[1] : "";

  return `${currencySymbol}${dollars + cents}`;
}

class CartDrawer extends PopupModal {

  constructor() {
    super();

    this.open = this.getAttribute('open') == "true";
    
    this.elContent = this.querySelector('[data-content]');
    this.elEmpty = this.querySelector('[data-empty]');
    this.elClose = this.querySelectorAll('[data-close]');
    this.elClose.forEach(el => el.addEventListener('click', this.toggleDrawer.bind(this)));

    fetchCart(false);
    window.toggleCart = this.toggleDrawer.bind(this);
    window.renderCart = this.renderCart.bind(this);
  }

  renderCart() {
    const isEmpty = window.cart.item_count == 0;
    if(isEmpty) {
      this.elContent.innerHTML = '';
      this.elContent.appendChild(this.elEmpty.content.cloneNode(true));
    } else {
      this.elContent.innerHTML = this.itemsTemplate();
    }

    const elQuantity = this.querySelectorAll('quantity-picker');
    elQuantity.forEach(el => {
      el.addEventListener('update', ({ detail }) => {
        window.updateCart({ updates: { [el.dataset.id]: detail } });
      })
    })
  }

  itemsTemplate() {
    const giftNote = window.cart.attributes['Gift Note'];

    return `
      <ul class="cart-drawer--items">
        ${window.cart.items.map(item => {
          const type = item.properties ? item.properties['_type'] : '';
          return `
            <li class="cart-drawer--item">
              <div class="cart-drawer--item-info">
                <h3 class="cart-drawer--item-title h2">
                  ${item.product_title} ${type ? type : ''}
                </h3>
                <p class="cart-drawer--item-details">
                  ${item.variant_title ? 
                    `<span class="cart-drawer--item-variant">
                      ${item.variant_title}
                    </span>` : ''
                  }
                  ${item.selling_plan_allocation ? 
                    `<span class="cart-drawer--item-subscription">
                      Delivery every ${item.selling_plan_allocation.selling_plan.name}
                    </span>` : ''
                  }
                </p>
                <strong class="h2">
                  ${item.selling_plan_allocation ? `<s>${formatMoney(item.selling_plan_allocation.compare_at_price, 0)}</s> ` : ''}${formatMoney(item.line_price, 0)}
                </strong>
                <quantity-picker
                  quantity="${item.quantity}"
                  data-name="updates[]"
                  data-id="${item.key}"
                  data-title="${item.title}"
                  class="cart-drawer--quantity"
                ></quantity-picker>
              </div>
              <div class="cart-drawer--item-image">
                <figure class="transparent">
                  <img 
                    src="${item.image}"
                    width="190"
                    height="226"
                    alt="An image of ${item.title}"
                    class="cover loaded"
                  />
                </figure>
              </div>
            </li>
          `
        }).join('')}
      </ul>
      <form 
        id="cart-form"
        action="/cart"
        method="post"
        class="cart-drawer--form"
      >
        <div class="cart-drawer--subtotal">
          <h3 class="h3">Subtotal</h3>
          <strong class="h3">${formatMoney(window.cart.total_price, 2)}</strong>
        </div>
        <cart-giftnote
          open="${giftNote ? true : false}"
          note="${giftNote ? giftNote : ''}"
          class="cart-drawer--giftnote"
        ></cart-giftnote>
        <input type="hidden" value="checkout" name="checkout" />
        <button type="submit" class="cart-drawer--submit btn">
          Check Out
        </button>
      </form>
    `
  }

  toggleDrawer(ev) {
    ev && ev.preventDefault();
    this.open = !this.open;
    this.setAttribute('open', this.open);
  }
}

class CartGiftnote extends HTMLElement {
  static observedAttributes = ["open", "note"];

  constructor() {
    super();

    this._internals = this.attachInternals();

    this.open = this.getAttribute('open') == 'true';
    this.note = this.getAttribute('note');

    this.elInput = '';

    this.render();
  }

  render() {
    this.innerHTML = `
      <div class="label">
        ${this.open ? 
          `Not a gift? <button type="button" data-delete>Delete note</button>` :
          `Sending as a gift? <button type="button" data-open>Add a note</button>` 
        }
      </div>
      <textarea
        name="attributes[Gift Message]"
        maxlength="300"
        placeholder="Add a gift note here [300 character limit]"
        aria-label="Gift Note"
        aria-hidden="${!this.open}"
        ${!this.open ? 'disabled' : ''}
      >${this.note}</textarea>
    `

    this.elInput = this.querySelector('textarea');
    this.elInput.addEventListener('change', ({ currentTarget }) => {
      this.setAttribute('note', currentTarget.value);
    });

    const elOpen = this.querySelector('[data-open]');
    elOpen && elOpen.addEventListener('click', () => this.setAttribute('open', true));

    const elDelete = this.querySelector('[data-delete]');
    elDelete && elDelete.addEventListener('click', () => {
      this.setAttribute('open', false);
      setTimeout(() => this.setAttribute('note', ''));
    })
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if(name == 'open') {
      this.open = newValue == 'true';
      this.open 
      this.open ? this._internals.states.add('open') : this._internals.states.delete('open');
      this.render();
    }

    if(name == 'note' && oldValue !== null && oldValue != newValue) {
      window.updateCart({ attributes: { 'Gift Note': newValue }})
    }
  }
}

customElements.define('cart-giftnote', CartGiftnote);
customElements.define('cart-drawer', CartDrawer);